export default "/images/eea92151653db72a975c17a6e79a5947.avif";